define('kitprDetailView',[
  'module',
  'kitprCreateEditLayoutView',
  'underscore',
  'marionette',
  'template!kitprDetailTabTpl',
  'settings'
], function (
  module,
  CreateEditLayoutView,
  _,
  Marionette,
  viewTpl,
  Settings
) {
  'use strict';

  var KitprDetailView = Marionette.ItemView.extend({
    template: viewTpl,

    modelEvents: {
      change: 'render'
    },

    events: {
      'click .js-edit': '_onEdit'
    },

    serializeData: function () {
      var templateData = this.model.toJSON();
      templateData.currentCAccountSecId = Settings.get('currentCAccount').secId;
      return templateData;
    },

    _onEdit: function() {
      var createEditView = new CreateEditLayoutView({
        kitprModel: this.model
      });
      createEditView.show({
        title: _.i18n('kitpr.edit')
      });
    }

  });

  module.exports = KitprDetailView;
});
